import DashboardPage from '../features/dashboard/DashboardPage';

export const HomePage = () => <DashboardPage />;
